import type { TransferReceiptTranslations } from "../interfaces/transferReceipt";

export const transferReceiptTranslations: TransferReceiptTranslations = {
  title: "Comprovante de transferência",
  status_settled: "Pagamento realizado",
  status_pending: "Em processamento",
  status_rejected: "Não concluído",
  notice_pending:
    "O pagamento ainda está em processamento: este comprovante ainda não confirma que o dinheiro chegou.",
  notice_rejected: "O pagamento não foi concluído e o dinheiro voltou para a carteira.",
  amount_settled: "Valor enviado",
  amount_pending: "Valor a caminho",
  amount_rejected: "Valor não enviado",
  via: "Via",
  number: "Número do comprovante",
  network_reference: "ID da transação Bre-B",
  to: "Para",
  from: "De",
  name: "Nome",
  entity: "Instituição",
  reference: "Referência",
  hash: "Hash da transação",
  network: "Rede",
  document: "Documento",
  account: "Conta",
  account_value: "Carteira {{currency}}",
  sent_through: "Enviado através de",
  sender_entity: "ColocaPayments SAS",
  footer: "Comprovante gerado pela Coloca Payments",
  file_prefix: "comprovante-coloca",
  share_text: "Te enviei {{amount}} com a Coloca.",
  destination_breb_key: "Chave",
  destination_pix_key: "Chave PIX",
  destination_bank_account: "Conta",
  destination_clabe: "CLABE",
  destination_cbu_cvu: "CBU/CVU",
  destination_crypto_wallet: "Carteira",
  savings_account: "Conta poupança",
  checking_account: "Conta corrente",
  alias: "Alias",
  view: "Ver comprovante",
  share_image: "Compartilhar imagem",
  share_pdf: "Compartilhar PDF",
  download_image: "Baixar imagem",
  download_pdf: "Baixar PDF",
  failed: "Não conseguimos gerar o comprovante. Tente novamente.",
};
